/**
 * @file 学んだ日の暦を、記録を読んでから出す入れ物である。
 *
 * @what: hooks/useStudyDays.ts で記録を読み、読み終えたら StudyDaysCalendar を出す。読んでいる間は
 *   1行の案内、読めなかったときは1行で知らせる (本だなの本体は影響を受けない)。
 * @failure: まなぶ人が未定なら何も出さない (記録はその人のもの)。
 */

import type { StudyNote } from "../api/notes";
import type { StudyProgressLog } from "../api/plans";
import type { StudySource } from "../api/sources";
import { useStudyDays } from "../hooks/useStudyDays";
import { StudyDaysCalendar } from "./StudyDaysCalendar";

export function StudyDaysCard({
  familyId,
  learnerPersonId,
  logs,
  notes,
  sourcesById,
}: {
  familyId: string;
  learnerPersonId: string | null;
  /** まなぶ人の直近の取り組みの記録である。 */
  logs: readonly StudyProgressLog[];
  /** 家族の学びメモ (まなぶ人での絞り込みは中で行う)。 */
  notes: readonly StudyNote[];
  sourcesById: ReadonlyMap<string, StudySource>;
}) {
  const state = useStudyDays(familyId, learnerPersonId, logs, notes, learnerPersonId !== null);
  if (state.status === "idle") return null;
  if (state.status === "loading") {
    return (
      <p role="status" className="study-muted">
        学んだ日を読み込んでいます...
      </p>
    );
  }
  if (state.status === "error") {
    return (
      <p role="alert" className="study-error">
        学んだ日を読み込めませんでした。時間を置いて再読み込みしてください。
      </p>
    );
  }
  return (
    <StudyDaysCalendar
      days={state.days}
      today={state.today}
      from={state.from}
      sourcesById={sourcesById}
    />
  );
}
